module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/hero-mobile-10b0a2f15f50e9efdf114b50f195d685.png";